import { Component } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { InitializerService } from './initializer.service';
import { HttpClientModule } from '@angular/common/http';
import { PrimeNG } from 'primeng/config';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HttpClientModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  providers: [InitializerService]
})
export class AppComponent {
  public title!: string;
  public urlApi!: string;
  public versionStorage!: string;


  constructor(private router: Router, private initializerService: InitializerService, private primeng: PrimeNG) {

    console.log("Iniciando aplicacao teste...");

    //Forcando o tema claro no dark
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
    if (prefersDark.matches) {
      document.documentElement.setAttribute('data-theme', 'dark');
    }

  }

  ngOnInit() {
    this.primeng.ripple.set(true);

    this.initializerService.getVersion().subscribe(version => {
      console.log("Versao: ",version);
      this.insertVersionIfEmpty(version);
    });



    // Requisição para carregar estilos
    this.initializerService.getStyle(window.location.origin).subscribe((response: any) => {

      const result: any = JSON.parse(response.stylesHost);
      this.title = result.title;
      this.alterStyleHost(result.theme);

    });
  }

  public alterStyleHost(objectStyles: any): void {
  console.log("Carregando styles WL");
  document.documentElement.style.setProperty('--primary-color', objectStyles.colors.primaryColor);
  document.documentElement.style.setProperty('--primary-color-hover', objectStyles.colors.primaryColorHover);
  document.documentElement.style.setProperty('--second-color', objectStyles.colors.secondColor);
  document.documentElement.style.setProperty('--dark-color', objectStyles.colors.darkColor);
  document.documentElement.style.setProperty('--light-color', objectStyles.colors.lightColor);
  document.documentElement.style.setProperty('--widthImage', objectStyles.image.widthImage);
  document.documentElement.style.setProperty('--heightImage', objectStyles.image.heightImage);
}


  public insertVersionIfEmpty(version: string): void {
    if(!localStorage.getItem('version')) {
      this.setVersion(version);
    }else{
      if(!this.compareVersion((localStorage.getItem('version') as string), version)) {
          this.equalsVersion(version);
      }
    }
  }

  public compareVersion(actual: string, newVersion: string){
    return actual === newVersion;
  }

  public setVersion(newVersion: string){
    localStorage.setItem('version', newVersion);
    this.hardReset();
  }

  public equalsVersion(version: string){
    this.setVersion(version);
  }

  public hardReset(): void{
    const url = window.location.origin + window.location.pathname + "?hard="+Date.now();

    console.log("Executando ajuste de equivalencia de versao");
    window.location.href=url;
  }

}
